import http from "./http"
const admin = {
  getListForPage(order, sort, page, size) {
    return http.get("setting/admin/list?order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size)
  },

  add(userId, remark, roleType) {
    return http.post("setting/admin/add?userId=" + userId + "&remark=" + remark + "&roleType=" + roleType)
  },

  delete(id) {
    return http.post("setting/admin/delete?id=" + id)
  },
}
export default admin
